module.exports = __webpack_public_path__ + "img/card-b8.9728668a.png";